import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useLocalePath } from "../../hooks/useLocalePath";
import { Icon } from "@iconify/react";

/**
 * Redirects authenticated users away from auth pages to their dashboard.
 */
const AuthRouteGuard = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const lp = useLocalePath();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Icon icon="svg-spinners:eclipse" className="w-12 h-12 text-primary" />
      </div>
    );
  }

  if (isAuthenticated && user) {
    const dashboardPath =
      user.role === "business" ? lp("/dashboard") : lp("/client/dashboard");
    return <Navigate to={dashboardPath} replace />;
  }

  return children;
};

export default AuthRouteGuard;
